/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames'
import './DraftBox.css';
import { humanize, createUrl } from '../../../../shared/helpers';

const handleClick = url => {
  if (url) {
    window.open(createUrl(url), '_blank');
  }
};

const renderDate = draft => {
  if (draft.due_date) {
    return (
      <div className="col-12 px-0 t-14 text-gray-light mb-1">
        { moment(draft.due_date, 'YYYY-MM-DD').format('MM/DD/YY') }
      </div>
    )
  }
};

const DraftBox = ({ draft, openDraftPopup, isManagerUser, addMarginBottom, disabled }) => {
  const { name, status, url } = draft;
  const className = disabled ? "disabled" : status

  const placeholders = {
    "draft_1": "First Draft",
    "draft_2": "Second Draft",
    "draft_3": "Third Draft",
    "draft_4": "Fourth Draft"
  };

  return (
    <React.Fragment>
      <div className={classnames("col-12", { "mb-4" : addMarginBottom })}>
        { renderDate(draft) }
        <div
          className={classnames(
            "col-12 mb-0",
            className,
            {
              "disabled" : disabled,
            }
          )}
          onClick={() => (isManagerUser ? openDraftPopup(true) : handleClick(url))}
        >
          {placeholders[name]}
        </div>
      </div>
    </React.Fragment>
  )
}

DraftBox.defaultProps = {
  dateFormat: 'YYYY-MM-DD',
};

DraftBox.propTypes = {
  draft: PropTypes.object,
  isManagerUser: PropTypes.bool,
  openDraftPopup: PropTypes.func,
  dateFormat: PropTypes.string,
  addMarginBottom: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};

export { DraftBox };



// WEBPACK FOOTER //
// ./src/components/ProjectView/DraftModal/DraftBox/DraftBox.js